import React from 'react';
import { HStack, Heading, Icon, Label } from '@medely/ui-kit';
import { useNavigate } from 'react-router-dom';

interface TopBarCleanProps {
  title: string;
  path?: string;
}

const TopBarClean = ({ title, path }: TopBarCleanProps): React.ReactElement => {
  const navigate = useNavigate();
  return (
    <HStack gap={4} justifyContent="center" alignItems="center" width="100%">
      {path && (
        <HStack
          onClick={() => {
            navigate(path);
          }}
          alignItems="center"
          position="absolute"
          left={0}
        >
          <Icon name="chevron-left" boxSize="32px" color="primary" variant="custom" />
          <Label size="l" color="state.teal.primary">
            Back
          </Label>
        </HStack>
      )}
      <Heading size="s">{title}</Heading>
    </HStack>
  );
};

export default TopBarClean;
